module.exports = __webpack_public_path__ + "static/media/auth-logo.a0e29177.svg";